import React from 'react'
import { Text } from '@/components/atoms/Text'
import { Icon } from '@/components/atoms/Icon'
import './Button.css'

export interface ButtonProps {
  label: string
  iconSrc?: string
  iconAlt?: string
  onClick?: () => void
  href?: string
  variant?: 'primary' | 'secondary' | 'outline'
  textSize?: 'small' | 'base' | 'large'
  className?: string
  target?: string
}

export const Button: React.FC<ButtonProps> = ({
  label,
  iconSrc,
  iconAlt = '',
  onClick,
  href,
  variant = 'primary',
  textSize = 'base',
  className = '',
  target,
}) => {
  const buttonClasses = [
    'button',
    `button-variant-${variant}`,
    className,
  ]
    .filter(Boolean)
    .join(' ')

  const content = (
    <>
      {iconSrc && (
        <div className="button-icon-wrapper">
          <Icon src={iconSrc} alt={iconAlt} size={24} />
        </div>
      )}
      <Text
        size={textSize}
        color={variant === 'outline' ? 'primary' : 'white'}
        weight="bold"
      >
        {label}
      </Text>
    </>
  )

  if (href) {
    return (
      <a href={href} className={buttonClasses} onClick={onClick} target={target} rel={target === '_blank' ? 'noopener noreferrer' : undefined}>
        {content}
      </a>
    )
  }

  return (
    <button type="button" className={buttonClasses} onClick={onClick}>
      {content}
    </button>
  )
}
